"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analysis = analysis;
exports.questions = void 0;
var questions = [{
  prompt: "",
  extraText: "What is your responsibility thought?",
  placeholder: "I feel guilty because…",
  tips: "TIPS: Don\u2019t worry if guilt isn\u2019t the right word for your feeling. You might just feel bad in some way. Look for what you feel responsible for in general that isn\u2019t working out how you want it to.",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "Who/what else had a role in this and what percent is their responsibility?",
  placeholder: "Write each person (or thing) and the percent (%) responsibility for each here…",
  tips: "TIPS: Consider whether any of the following played a role: your parents, your friends, your colleagues, other influential people. How did their personal choices affect this? Also consider: education, alcohol, stress, illness, money, environment, culture and anything that is outside of your personal control.",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "How much responsibility is left after your add up everyone else’s roles?",
  placeholder: "Write the percent that is left over here...",
  tips: "TIPS: If you still feel like you are mostly responsible, it might help to go back a step and see if there is anything else that played a role in the outcome.",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "Is there anything I can do to repair this situation so I can move on?",
  placeholder: "Write any actions you could take here...",
  tips: "TIPS: If there is a role remaining for yourself then maybe there is someone you could make amends and apologise to. You don’t have to do anything and it might be better not to if you can now see that your role was very minor.",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "What is the next thought I need to retrain?",
  placeholder: "Write down any reasons why the thought still feels true here...",
  tips: "TIPS: After starting to retrain a thought, it is normal for it to still feel somewhat true. This is because there are other, related thoughts that need to be retrained too. Unhelpful thoughts are linked together in clusters that make up belief systems. To identify the next thought in the cluster, ask yourself: Why does my unhelpful thought still feel true? Write down any reasons you think of. These unhelpful thoughts are the next ones that you’ll need to retrain to change your mindset.",
  type: "multirow",
  aggregated: true
}];
exports.questions = questions;

function analysis(answers) {
  return {
    answers: answers.slice(0, 4),
    rootThought: answers[4]
  };
}

;